<template>
<div class="form-submission-card-content container">
    <div class="row row-cols-2 row-cols-md-3">
        <response-text
            question="Make"
            :answer="tool_computed.make"
        />

        <response-text
            question="Model"
            :answer="tool_computed.model"
        />

        <response-text
            question="Serial Number"
            :answer="certificate.tool.serial_number ?? 'N/A'"
        />

        <response-text
            question="Trigger Time"
            :answer="tool_computed.trigger_time ?? 'N/A'"
        />

        <response-text
            question="SWL Capacity"
            :answer="certificate.tool.swl_capacity ? certificate.tool.swl_capacity + ' ' + certificate.tool.swl_capacity_unit : 'N/A'"
        />

        <response-text
            question="Location"
            :answer="tool_computed.location ?? 'N/A'"
        />

        <response-text
            question="Noise Output"
            :answer="certificate.tool.noise_output ? `${certificate.tool.noise_output} db` : 'N/A'"
        />

        <response-text
            question="Vibration Output"
            :answer="certificate.tool.vibration_output ? `${certificate.tool.vibration_output} ms2` : 'N/A'"
        />

        <response-text
            question="PUWER"
            :answer="tool_computed.puwer_expiry_formatted"
            v-bind:class="getExpiryColor(tool_computed.puwer_expiry)"
        />

        <response-text
            question="PSSR"
            :answer="tool_computed.pssr_expiry_formatted"
            v-bind:class="getExpiryColor(tool_computed.pssr_expiry)"
        />

        <response-text
            question="COSHH"
            :answer="tool_computed.coshh_expiry_formatted"
            v-bind:class="getExpiryColor(tool_computed.coshh_expiry)"
        />

        <response-text
            question="LOLER"
            :answer="tool_computed.loler_expiry_formatted"
            v-bind:class="getExpiryColor(tool_computed.loler_expiry)"
        />

        <response-text
            question="LEV"
            :answer="tool_computed.lev_expiry_formatted"
            v-bind:class="getExpiryColor(tool_computed.lev_expiry)"
        />

        <response-text
            question="PAT"
            :answer="tool_computed.pat_expiry_formatted"
            v-bind:class="getExpiryColor(tool_computed.pat_expiry)"
        />

        <response-text
            question="Calibration"
            :answer="tool_computed.calibration_expiry_formatted"
            v-bind:class="getExpiryColor(tool_computed.calibration_expiry)"
        />
    </div>

    <gallery-view-component
        v-if="certificate.documents && certificate.documents.length > 0"
        class="form-submission-card-content-child"
        :photos="certificate.documents"
    />

    <sticker-view-component
        v-if="tool_computed.stickers && tool_computed.stickers.length > 0"
        class="form-submission-card-content-child"
        :photos="tool_computed.stickers"
    />
</div>
</template>

<script>
import GalleryViewComponent from '../general_components/GalleryViewComponent';
import StickerViewComponent from '../general_components/StickerViewComponent';
import ResponseText from '../submissions/responses/ResponseText.vue';

export default {
    name: 'ToolCertificateContent',
    components: {
        GalleryViewComponent,
        StickerViewComponent,
        ResponseText,
    },
    props: {
        certificate: {
            type: Object,
            required: true,
        },
        hide_title: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        getExpiryColor(date) {
            if (!date) return null; //don't change text
            const js_date = Date.parse(date);

            return Date.parse(new Date()) <= js_date
                ? 'text-success'
                : 'font-weight-bold text-danger';
        },
    },
    computed: {
        tool_computed() {
            return this.certificate.tool;
        },
    },
};
</script>
